var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more_vert_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/more_vert_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 6.66634C10.9163 6.66634 11.6663 5.91634 11.6663 4.99967C11.6663 4.08301 10.9163 3.33301 9.99967 3.33301C9.08301 3.33301 8.33301 4.08301 8.33301 4.99967C8.33301 5.91634 9.08301 6.66634 9.99967 6.66634ZM9.99967 8.33301C9.08301 8.33301 8.33301 9.08301 8.33301 9.99967C8.33301 10.9163 9.08301 11.6663 9.99967 11.6663C10.9163 11.6663 11.6663 10.9163 11.6663 9.99967C11.6663 9.08301 10.9163 8.33301 9.99967 8.33301ZM8.33301 14.9997C8.33301 14.083 9.08301 13.333 9.99967 13.333C10.9163 13.333 11.6663 14.083 11.6663 14.9997C11.6663 15.9163 10.9163 16.6663 9.99967 16.6663C9.08301 16.6663 8.33301 15.9163 8.33301 14.9997Z",
    fill: "#8993A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more_vertical.b6885a8bb79cd3f015f21cabdd9ccb9f.svg";
export { ForwardRef as ReactComponent };